(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/use-build-animations.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/use-build-animations.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _svs$components$onboa = svs.components.onboarding.slides.animations.composers,
  keepComposerAsync = _svs$components$onboa.keepComposerAsync,
  slideComposerAsync = _svs$components$onboa.slideComposerAsync;
const _svs$components$onboa2 = svs.components.onboarding.slides.animations,
  createSlideLeftAsync = _svs$components$onboa2.createSlideLeftAsync,
  createSlideRightAsync = _svs$components$onboa2.createSlideRightAsync,
  createResetPositions = _svs$components$onboa2.createResetPositions;

const useBuildAnimations = (animations, keepSlides) => useMemo(() => {
  const composer = keepSlides ? keepComposerAsync : slideComposerAsync;
  return [createResetPositions(animations.setCenter, animations.setRight), createSlideLeftAsync(composer, animations.toCenter, animations.toLeft, animations.setRight), createSlideRightAsync(composer, animations.toCenter, animations.toRight, animations.setLeft)];
}, [keepSlides, animations.toCenter, animations.toLeft, animations.toRight, animations.setCenter, animations.setLeft, animations.setRight]);
setGlobal('svs.components.onboarding.slides.useBuildAnimations', useBuildAnimations);

 })(window);